<template>
  <div>
    <v-card style="" class="mx-auto my-12">
      <template slot="progress">
        <v-progress-linear
          color="deep-purple"
          height="10"
          indeterminate
        ></v-progress-linear>
      </template>

      <v-img style="z-index: 1" height="250" :src="img"></v-img>
      <div class="gradient" style="z-index: 2">
        <v-card-title class="justify-center"
          ><b style="color: white; font-size: 2rem; font-family: Poiret One">{{
            name
          }}</b></v-card-title
        >
        <div
          id="divider"
          style="background-color: white; height: 0.5rem; width: 80%; margin: auto"
        ></div>
        <br />
        <v-card-text>
          <v-row align="center" class="mx-0">
            <div class="grey--text ml-4">
              <b style="font-size: 1.2rem !important; color: white"
                >Impartido por: {{ instructor }}</b
              >
            </div>
            <div
            class="grey--text ml-4"
            style="font-size: 1.2rem !important; color: white"
          >
            Fecha: {{ dateFormated }}
          </div>
          </v-row>
          <br />          

           <div
            class="my-4 subtitle-1"
            style="text-align: center; font-size: 1rem !important; color: white;"
          >
            Descripción: {{ description }}
          </div>
        </v-card-text>
      </div>

      <v-divider class="mx-4"></v-divider>
      <v-btn block color="#ffffff" style="color: #000000" @click="sendVideo">
        Ver Video</v-btn
      >
    </v-card>
  </div>
</template>
<script>

export default {
  props: {
    prog2: String,
    name: String,
    img: { type: String, default: "https://cdn.vuetifyjs.com/images/cards/cooking.png" },
    instructor: String,
    id: String,
    serie: String,
    description: String,
    video_type: String,
    dateFormated: String,
    paginationTab: Number
  },
  data() {
    return {};
  },
  methods: {
    sendVideo() {
     this.$store.commit("setInitialTab", this.paginationTab);
      if ("videos" == this.video_type) {
        this.$store.commit("clearVideoIdFromFirebase");
        this.$store.commit("setVideoIdFromFirebase", this.id);
        this.$router.push({ name: "Video", params: { id: this.id } });
      } else if ("Stream" == this.video_type){
        this.$router.push({ name: "Stream_Video", params: { id: this.id } });
      }
    }
  },
};
</script>
<style scoped>
.gradient {
  background: linear-gradient(
    to top left,
    rgba(0, 0, 0, 1) 25%,
    rgba(0, 0, 0, 1) 25%,
    rgba(0, 0, 0, 1) 25%,
    rgba(0, 0, 0, 1) 25%
  );
}
</style>



// WEBPACK FOOTER //
// src/components/library_components/video_card.vue